export { default } from './withPrivateRoute';
